/**
 * 用户邮箱配置API调用模块
 * 提供用户邮箱配置的CRUD操作接口
 */

import apiClient from "./axios";

const BASE_URL = "/v1/user/email-configs";

/**
 * 获取用户邮箱配置列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页数量
 * @returns {Promise} API响应
 */
export const getUserEmailConfigs = (params = {}) => {
    const { page = 1, page_size = 20 } = params;
    return apiClient.get(BASE_URL, {
        params: { page, page_size },
    });
};

/**
 * 获取邮箱配置详情
 * @param {number} configId - 配置ID
 * @returns {Promise} API响应
 */
export const getEmailConfigById = (configId) => {
    return apiClient.get(`${BASE_URL}/${configId}`);
};

/**
 * 创建邮箱配置
 * @param {Object} configData - 邮箱配置数据
 * @returns {Promise} API响应
 */
export const createEmailConfig = (configData) => {
    return apiClient.post(BASE_URL, configData);
};

/**
 * 更新邮箱配置
 * @param {number} configId - 配置ID
 * @param {Object} updateData - 更新数据
 * @returns {Promise} API响应
 */
export const updateEmailConfig = (configId, updateData) => {
    return apiClient.put(`${BASE_URL}/${configId}`, updateData);
};



/**
 * 测试邮箱配置
 * @param {number} configId - 配置ID
 * @param {Object} testData - 测试数据（可选）
 * @returns {Promise} API响应
 */
export const testEmailConfig = (configId, testData = {}) => {
    return apiClient.post(`${BASE_URL}/${configId}/test`, testData);
};

/**
 * 获取默认邮箱配置
 * @returns {Promise} API响应
 */
export const getDefaultEmailConfig = () => {
    return apiClient.get(`${BASE_URL}/default/config`);
};

/**
 * 获取用户所有启用的邮箱配置（用于发件人选择）
 * @returns {Promise} API响应
 */
export const getActiveEmailConfigs = async () => {
    const response = await getUserEmailConfigs({ page: 1, page_size: 100 });
    // 过滤出启用的配置
    const activeConfigs = response.data.items.filter((config) => config.is_active);
    return {
        ...response,
        data: {
            items: activeConfigs,
            total: activeConfigs.length,
        },
    };
};

export default {
    getUserEmailConfigs,
    getEmailConfigById,
    createEmailConfig,
    updateEmailConfig,
    testEmailConfig,
    getDefaultEmailConfig,
    getActiveEmailConfigs,
};
